import { render } from "./RelatorioCompras.vue?vue&type=template&id=7d5d216f"
import script from "./RelatorioCompras.vue?vue&type=script&lang=js"
export * from "./RelatorioCompras.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__